import React, { useEffect, useState } from "react";
import "./group.css";
import Header from "./Header";
import GroupBody from "./GroupBody";
import { useLocation, useNavigate } from "react-router-dom";
import apiServiceHandler from "../../../service/apiService";
import { useDispatch, useSelector } from "react-redux";
import {
  handleLoadUsers,
  hanldeGroupData,
  setGroupInfo,
  toggleGroupMembersModal,
} from "../../../redux/groupData";
import { ChevronLeft } from "lucide-react";

const Group = () => {
  const [groupData, setGroupData] = useState();
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const loadGroupData = useSelector((state) => state.groupData.loadGroupData);

  const { pathname } = useLocation();
  const pathArr = pathname.split("/");
  const id = pathArr[pathArr.length - 1];

  const getGroupData = async () => {
    try {
      const response = await apiServiceHandler("GET", `api/groups/${id}`, {});
      setGroupData(response.data[0]);
      dispatch(setGroupInfo(response.data[0]));
    } catch (error) {
      console.error("Error getting group info:", error);
    }
  };

  useEffect(() => {
    getGroupData();
  }, []);

  useEffect(() => {
    if (loadGroupData) {
      getGroupData();
    }
    dispatch(hanldeGroupData(false));
  }, [loadGroupData]);

  return (
    <>
      <div className="page-back">
        <button className="back-button" onClick={() => navigate('/groups')}>
          <span className="icon">
            <ChevronLeft size={32} />
          </span>
          <span className="button-label">Back</span>
        </button>
      </div>
      <div className="group-section">
        <Header groupData={groupData} />
        <GroupBody />
      </div>
    </>
  );
};

export default Group;
